/**
 * List of all english error messages by error code 
 */
const _messagesEN = {
    530: "An unexpected error occurred",
    531: "Invalid login or password"
};

type ErrorMessageRecord = typeof _messagesEN;

/**
 * List of all french error messages by error code 
 */
const _messagesFR: ErrorMessageRecord = {
    530: "Une erreur inattendue s'est produite",
    531: "Identifiant ou mot de passe incorrect"
};

/**
 * Action related error messages per language and per code (messages["fr"][900])
 */
export const ERROR_MESSAGES = {
    "en": _messagesEN,
    "fr": _messagesFR
};